<template>
  <generic-error no-appbar>
    <template v-slot:title>Formulaire inaccessible</template>
    <h1>Accès non autorisé</h1>
    <p>
      Désolé, le formulaire de modification et de création de carte d'affaire n'est pas accessible car vous avez un formulaire de renouvellement en cours.
      Vous devez d'abord le compléter avant de pouvoir créer ou modifier votre/vos carte(s) d'affaire(s).
    </p>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  components: {
    GenericError
  }
}
</script>

<style>
</style>
